import React from "react"
import CompareUnit from "../components/pages/compare-unit/compare-unit"

// const CompareUnitPage = props => null
const CompareUnitPage = props => <CompareUnit {...props} />

export default CompareUnitPage
